import React from 'react'

const Loading = () => {
  return (
    <div className="flex w-full bg-primary/[0.6] backdrop-blur-sm h-full z-[1000] justify-center items-center absolute">
      <div className="flex justify-center items-center w-[150px] drop-shadow-md h-[150px] rounded-md bg-background/[0.3]">
        <div className=" border-t-4 border-bg_bet dark:border-primary border-solid h-24 w-24 rounded-full animate-spin"></div>
      </div>
    </div>
  );
}

export default Loading